import { SCHEDULE_FREQUENCY } from '../consts';
import type { ScheduleFrequency } from '../types';

/** Whether a raw Select value is a schedule frequency, narrowing it without a cast. */
export const isScheduleFrequency = (value: string): value is ScheduleFrequency =>
  Object.values(SCHEDULE_FREQUENCY).some((frequency) => frequency === value);
